// React
import React from 'react'
import PropTypes from 'prop-types'

// Components
import { Free as OrderFree } from 'ui/components/Picker/types/order/Free'
import { Timeslots as OrderTimeslots } from 'ui/components/Picker/types/order/Timeslots'
import { Durations as OrderDurations } from 'ui/components/Picker/types/order/Durations'
import { Free as CartFree } from 'ui/components/Picker/types/cart/Free'
import { Timeslots as CartTimeslots } from 'ui/components/Picker/types/cart/Timeslots'
import { Durations as CartDurations } from 'ui/components/Picker/types/cart/Durations'
import { Picker } from 'ui/components/Picker/Picker'

export const OrderFlowPicker = (props) => (
  <Picker {...props} components={{ Free: OrderFree, Timeslots: OrderTimeslots, Durations: OrderDurations }} />
)

export const CartFlowPicker = (props) => (
  <Picker
    {...props}
    components={{ Free: CartFree, Timeslots: CartTimeslots, Durations: CartDurations }}
    inline={props.inline !== undefined ? props.inline : true}
    translate
  />
)

CartFlowPicker.propTypes = {
  inline: PropTypes.bool
}
